export default __webpack_public_path__ + "static/media/047-zebra.323b0920.svg";